// extracted by mini-css-extract-plugin
export default {"primary":"style_primary__-pljG","secondary":"style_secondary__DptsN"};